

import React, { Component, Fragment } from 'react'
import ProgressMeterWithLogo from 'components/ProgressMeterWithLogo'
import { OnboardingHeader } from 'components/OnboardingHeader'
import { Icon, Input, Button, Div, H4, H5 } from '@drifthq/tide-core'
import { Select } from '@drifthq/tide-selects'
import tc from 'tinycolor2'
import previewConvoSrc from './convo-area@2x.png'
import { pathOr } from 'ramda'
import { uploadFile } from 'modules/file/api'
import { UploadArea } from '@drifthq/tide-file-upload'
import { ColorPicker, GradientPicker } from 'components/ColorPicker'
import { api } from 'modules/playbook/api'
import { getRandomGradient } from './helpers'
import { track } from 'utils/trackingUtils'

import './style.css'

const BACKGROUND_OPTIONS = {
  GRADIENT: 'Gradient',
  IMAGE: 'Image',
  SOLID_COLOR: 'Solid Color',
}

const BACKGROUND_DROPDOWN_OPTIONS = [
  { value: 'Gradient', label: 'Gradient' },
  { value: 'Solid Color', label: 'Solid Color' }
]

const BrandingOptions = {
  LOGO: 'Logo',
  NONE: 'No branding',
  CUSTOM: 'Custom image',
}

const imageFileExtensions = ['jpg', 'jpe', 'jpeg', 'png', 'gif']

const ConversationPreview = ({ firstBackgroundGradient, secondBackgroundGradient, showLogo, logoUrl, customLogo, showCustomImage, companyName }) => (
  <Div className="clp-preview-window-container">
    <Div className="clp-preview-window-header">
      <Div className="clp-preview-window-header-address-bar"></Div>
    </Div>
    <Div className="clp-preview-background-page" style={{ background: `linear-gradient(135deg, ${firstBackgroundGradient}, ${secondBackgroundGradient})` }}>
      <Div className="clp-preview-image-container">
        {(showLogo && logoUrl) && <Div className="clp-preview-background-logo"><img alt="company logo" className="clp-preview-background-logo-image" src={logoUrl} /></Div>}
        {(showCustomImage && customLogo) && <Div className="clp-preview-background-logo"><img alt="custom logo" className="clp-preview-background-logo-image" src={customLogo} /></Div>}
        {!(logoUrl || customLogo) && !(!showLogo && !showCustomImage) && <Div className="clp-preview-background-logo--placeholder"> <Icon width={18} height={18} name="photo" /> </Div>}
        {!showLogo && !showCustomImage && <Div className="clp-preview-background-logo">{companyName}</Div>}
      </Div>
      <img className="clp-preview-image" src={previewConvoSrc} alt="preview conversation" />
    </Div>
  </Div>
)

class CLPCustomizeStep extends Component {

  constructor(props) {
    super(props)

    this.state = {
      backgroundOption: props.landingPageSettings.backgroundOption || BACKGROUND_DROPDOWN_OPTIONS[0],
      firstBackgroundGradient: props.landingPageSettings.firstGradientColor || '#5767e4',
      secondBackgroundGradient: props.landingPageSettings.secondGradientColor || '#429CD0',
      customLogo: props.landingPageSettings.customLogo,
      brandingOption: BrandingOptions[props.landingPageSettings.brandingOption] || BrandingOptions.NONE,
      status: "ENABLED",
      path: props.landingPageSettings.path || ''
    }

  }

  componentDidMount() {
    const { actions } = this.props
    actions.fetchCLPCname()
    actions.fetchCLPSubdomain()
  }

  componentDidUpdate(prevProps) {
    const { landingPageSettings } = this.props

    if (prevProps.landingPageSettings.customLogo !== landingPageSettings.customLogo) {
      this.setState({customLogo: landingPageSettings.customLogo})
    }

    if (prevProps.landingPageSettings.firstGradientColor !== landingPageSettings.firstGradientColor) {
      this.setState({firstBackgroundGradient: landingPageSettings.firstGradientColor})
    }

    if (prevProps.landingPageSettings.secondGradientColor !== landingPageSettings.secondGradientColor) {
      this.setState({secondBackgroundGradient: landingPageSettings.secondGradientColor})
    }

    if (prevProps.landingPageSettings.backgroundOption !== landingPageSettings.backgroundOption) {
      this.setState({backgroundOption: landingPageSettings.backgroundOption})
    }

    if (prevProps.landingPageSettings.brandingOption !== landingPageSettings.brandingOption) {
      this.setState({brandingOption: BrandingOptions[landingPageSettings.brandingOption]})
    }

    if (prevProps.landingPageSettings.path !== landingPageSettings.path) {
      this.setState({path : landingPageSettings.path})
    }

    if (!prevProps.playbookId && !!this.props.playbookId) {
      const { actions, playbookId } = this.props
      actions.fetchCLPSettings(playbookId)
    }
  }

  onLogoTypeError = () => {
    this.setState({
      uploadFileFailed: true,
      uploadFailMessage: `Only the following image extensions are accepted: ${imageFileExtensions.join(', ')}`,
    })
  }

  onLogoSizeError = () => {
    this.setState({
      uploadFileFailed: true,
      uploadFailMessage: `Your logo should be less than 500px x 300px.`,
    })
  }

  onLogoReadError = (err) => {
    this.setState({
      uploadFileFailed: true,
      uploadFailMessage: pathOr('Unable to upload your file', ['response', 'data', 'message'], err),
    })
  }

  handleSaveLogo = (logoUrl) => {
    this.setState({ customLogo: logoUrl,
      uploadFileFailed: false,
    })
  }

  renderClpPreview = () => {
    const {
      firstBackgroundGradient,
      secondBackgroundGradient,
      brandingOption,
      customLogo,
    } = this.state

    const {
      logoUrl,
      companyName
    } = this.props
    return (
      <Div>
        <Div className="clp-customize--preview-container">
          <H5>PREVIEW</H5>
          <ConversationPreview
            showLogo={brandingOption === BrandingOptions.LOGO}
            showCustomImage={brandingOption === BrandingOptions.CUSTOM}
            logoUrl={logoUrl}
            customLogo={customLogo}
            firstBackgroundGradient={firstBackgroundGradient}
            secondBackgroundGradient={secondBackgroundGradient}
            companyName={companyName}
          />
        </Div>
      </Div>
    )
  }

  renderBackgroundSection = () => {
    const {
      firstBackgroundGradient,
      secondBackgroundGradient,
      backgroundOption
    } = this.state

    return (
      <Div className="clp-customize--bg-branding-content clp-customize--bg-first-branding-content">
        <H4>Background</H4>
        <Select
          className="clp-customize--bg-select"
          value={backgroundOption}
          options={BACKGROUND_DROPDOWN_OPTIONS}
          onChange={this.onSelectBackgroundOption}
          isClearable={false}
          isSearchable={false}
        />
        {backgroundOption.value === BACKGROUND_OPTIONS.GRADIENT &&
          <Div className="clp-customize--bg-select-color-pickers">
            <GradientPicker
              firstBackgroundGradient={firstBackgroundGradient}
              secondBackgroundGradient={secondBackgroundGradient}
              onFirstBgColorChange={this.onFirstBgColorChange}
              onSecondBgColorChange={this.onSecondBgColorChange}
            />
            <Div className="clp-customize-random-gradient">
              Need a suggestion? <span onClick={this.randomizeGradient}>Try a random gradient</span>
            </Div>
          </Div>
        }
        {backgroundOption.value === BACKGROUND_OPTIONS.SOLID_COLOR &&
          <Fragment>
            <ColorPicker
              color={firstBackgroundGradient}
              onColorChange={this.onSolidColorChange}
            />
          </Fragment>
        }
      </Div>
    )
  }

  onSolidColorChange = (color) => {
    this.setState({
      firstBackgroundGradient: color.hex,
      secondBackgroundGradient: color.hex
    })
  }

  onFirstBgColorChange = (color) => {
    this.setState({
      firstBackgroundGradient: color.hex
    })
  }

  onSecondBgColorChange = (color) => {
    this.setState({
      secondBackgroundGradient: color.hex
    })
  }

  onSelectBackgroundOption = (option) => {
    const { firstBackgroundGradient } = this.state

    if (option.value === BACKGROUND_OPTIONS.SOLID_COLOR) {
      this.setState({
        backgroundOption: option,
        firstBackgroundGradient: firstBackgroundGradient,
        secondBackgroundGradient: firstBackgroundGradient
      })
    } else {
      this.setState({
        backgroundOption: option,
      })
    }
  }

  randomizeGradient = () => {
    const randomGradient = getRandomGradient()
    this.setState({
      firstBackgroundGradient: randomGradient[0],
      secondBackgroundGradient: randomGradient[1],
    })
  }

  setBrandingToLogo = () => {
    this.setState({
      brandingOption: BrandingOptions.LOGO,
    })
  }

  setBrandingToNone = () => {
    this.setState({
      brandingOption: BrandingOptions.NONE,
    })
  }

  setBrandingToCustom = () => {
    this.setState({
      brandingOption: BrandingOptions.CUSTOM,
    })
  }

  handleClearLogo = () => {
    this.setState({
      customLogo: null,
    })
  }


  renderBrandingSection = () => {
    const {
      firstBackgroundGradient,
      secondBackgroundGradient,
      brandingOption,
      customLogo,
      uploadFileFailed,
      uploadFailMessage
    } = this.state

    const {
      logoUrl,
      companyName
    } = this.props

    return (
      <Div className="clp-customize--bg-branding-content">
        <H4>Branding</H4>
        <Div className="clp-customize--bg-branding-select-container">
          <Input type="radio" name="branding" onClick={this.setBrandingToLogo} checked={brandingOption === BrandingOptions.LOGO} />
          <label>Logo</label>
          <Input type="radio" name="branding" onClick={this.setBrandingToCustom} checked={brandingOption === BrandingOptions.CUSTOM} />
          <label>Custom logo</label>
          <Input type="radio" name="branding" onClick={this.setBrandingToNone} checked={brandingOption === BrandingOptions.NONE} />
          <label>Company name</label>
        </Div>
        {brandingOption === BrandingOptions.LOGO &&
          <span>
            {!!logoUrl ?
              <Div className="clp-customize--branding-logo" style={{ background: `linear-gradient(135deg, ${firstBackgroundGradient}, ${secondBackgroundGradient})`, color: tc.mostReadable(firstBackgroundGradient, ["#000", "#fff"]).toHexString() }}>
                <img alt="company logo" className="clp-customize--branding-logo-img" src={logoUrl} />
              </Div>
              :
              <Div className="clp-customize--branding-logo-error">
                <Icon className="error-icon" name="warning-triangle" width="18" height="18" />
                We can’t find a logo associated with your account.
              </Div>
            }
          </span>
        }
        {brandingOption === BrandingOptions.CUSTOM &&
        <Fragment>
          <UploadArea
            className="clp-custom-logo-upload"
            onSizeError={this.onLogoSizeError}
            onTypeError={this.onLogoTypeError}
            onReadError={this.onLogoReadError}
            handleUploadFile={uploadFile}
            handleSaveFile={this.handleSaveLogo}
            previewUrl={customLogo}
          />
          {uploadFileFailed && <Div className="clp-custom-logo-upload--error">{uploadFailMessage}</Div>}
          {!!customLogo && <Button className="clp-custom-logo-upload--clear" type="secondary" onClick={this.handleClearLogo}>
            Clear Image
          </Button>}
          </Fragment>
        }

        {brandingOption === BrandingOptions.NONE &&
          <Div className="clp-customize-preview-name-background" style={{ background: `linear-gradient(135deg, ${firstBackgroundGradient}, ${secondBackgroundGradient})` }}>
            {companyName}
          </Div>}
      </Div>
    )
  }


  doSave = () => {
    const { brandingOption, firstBackgroundGradient, secondBackgroundGradient, path, customLogo, status } = this.state
    const { actions : { updateCLPSettings }, playbookId } = this.props

    const brandingEnumOption = Object.entries(BrandingOptions).filter((entry) => entry[1] === brandingOption).map((entry) => entry[0])[0]

    const settings = {
      brandingOption: brandingEnumOption,
      firstGradientColor: firstBackgroundGradient,
      secondGradientColor: secondBackgroundGradient,
      path: path,
      customLogo: customLogo,
      status: status
    }

    try {
      updateCLPSettings({playbookId, settings})
      this.checkSubdomain()
    } catch (e) {
      console.warn(e)
    }
  }

  checkSubdomain = async () => {
    const { landingPageSubdomain, onContinue, handle } = this.props
    if (!!landingPageSubdomain) {
      this.skipSubdomainStep()
    }
    else { //check if handle is valid subdomain. if not, push to next step
      try {
        const data = await api.updateLandingPageSubdomain(handle)
        const { actions } = this.props
        actions.setCLPSubdomain(data.subdomain)
        this.skipSubdomainStep()
      }
      catch (e) {
        const { name, segment } = this.props
        if (e && e.status === 409) {
          console.warn("Handle is already used as a CLP subdomain name")
          track(`${name} Step - Subdomain Error`, { context: 'handle is already CLP name', handle: handle, segment: segment })
        }
        onContinue()
      }
    }
  }

  skipSubdomainStep = () => {
    const { history, name, segment } = this.props
    history.push('/onboarding/clp/url')
    track(`${name} Step - Continued`, { route: '/customize', segment: segment })
  }

  render() {

    const { stepCount, index } = this.props
    return (
      <Fragment>
        <ProgressMeterWithLogo currentLength={index} maxLength={stepCount - 1} />
        <OnboardingHeader
          title="Generate a custom landing page"
          description="No code necessary 😉"
        />
        {this.renderClpPreview()}
        <Div className="clp-customize--bg-branding-container">
          {this.renderBackgroundSection()}
          {this.renderBrandingSection()}
        </Div>
        <Button className="clp-customize--next-button" size="large" onClick={this.doSave}>
          Next
        </Button>
        <Div className="clp-customize--bottom-padding"/>
      </Fragment>
    )
  }
}

export default CLPCustomizeStep



// WEBPACK FOOTER //
// ./src/layouts/OnboardingCLPCustomizeStep/index.js